import { render, staticRenderFns } from "./ProvidersAddEditModal.vue?vue&type=template&id=64a2babf&scoped=true&"
import script from "./ProvidersAddEditModal.vue?vue&type=script&lang=js&"
export * from "./ProvidersAddEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ProvidersAddEditModal.vue?vue&type=style&index=0&id=64a2babf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a2babf",
  null
  
)

export default component.exports